/// <amd-module name="VSSUI/Components/Header/HeaderIcon" />
import * as React from "react";

import { IHeaderIconProps, TitleSize } from "./Header.Props";

import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";

export class HeaderIcon extends React.Component<IHeaderIconProps> {
    public render() {
        let titleSizeClass = undefined;
        switch (this.props.titleSize) {
            case TitleSize.Large:
                titleSizeClass = "l";
                break;
            case TitleSize.Small:
                titleSizeClass = "s";
                break;
            case TitleSize.Medium:
            default:
                titleSizeClass = "m";
        }
        return <div className={css(this.props.className, "bolt-header-icon", titleSizeClass)}>{Icon(this.props.iconProps)}</div>;
    }
}
